import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [isCookieMenuOpen, setIsCookieMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('privacy');

  const toggleVisibility = () => {
    if (window.pageYOffset > document.documentElement.scrollHeight / 4) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleCookieClick = () => {
    setIsCookieMenuOpen(!isCookieMenuOpen);
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
      <div className="scroll-to-top">
        {isVisible && (
          <button onClick={scrollToTop} className="scroll-button" title="Back to top">
            <img src="/icons/general/scroll.png" alt="Scroll to top" />
          </button>
        )}
      </div>
      <button className={`cookie-settings-button ${isCookieMenuOpen ? 'flipped' : ''}`} onClick={handleCookieClick} title="Cookie Settings">
        <img className="cookie-icon" src="/icons/general/cookies.png" alt="Cookie settings" />
        <span className="cookie-close-x">✕</span>
      </button>

      {isCookieMenuOpen && (
        <div className="cookie-modal-overlay">
          <div className="cookie-modal">
            <div className="cookie-modal-header">
              <img src="/images/general/TytonLogo-transparent.png" alt="Tyton" className="cookie-modal-logo" />
              <h2>Privacy Preferences</h2>
              <button className="cookie-modal-close" onClick={handleCookieClick} title="Close">
                ✕
              </button>
            </div>
            <div className="cookie-modal-content-wrapper">
              <nav className="cookie-modal-nav">
                <button className={`cookie-nav-item ${activeTab === 'privacy' ? 'active' : ''}`} onClick={() => setActiveTab('privacy')}>Your Privacy</button>
                {activeTab === 'privacy' && (
                  <div className="cookie-modal-main">
                    <h3>Your Privacy</h3>
                    <p>We respect your privacy and are committed to transparency about how we use your data. You control which cookies we can use to enhance your experience.</p>
                    <p>Choose your cookie preferences below and we'll respect your choices across all our services.</p>
                  </div>
                )}
                <button className={`cookie-nav-item ${activeTab === 'necessary' ? 'active' : ''}`} onClick={() => setActiveTab('necessary')}>Necessary Cookies</button>
                {activeTab === 'necessary' && (
                  <div className="cookie-modal-main">
                    <div className="cookie-toggle-header">
                      <div>
                        <h3>Necessary Cookies</h3>
                        <p>Essential for core functionality. Always active.</p>
                      </div>
                      <input type="checkbox" defaultChecked disabled />
                    </div>
                    <p>These cookies are required for the website to function and cannot be disabled. They include session management and security features.</p>
                  </div>
                )}
                <button className={`cookie-nav-item ${activeTab === 'performance' ? 'active' : ''}`} onClick={() => setActiveTab('performance')}>Performance Cookies</button>
                {activeTab === 'performance' && (
                  <div className="cookie-modal-main">
                    <div className="cookie-toggle-header">
                      <div>
                        <h3>Performance Cookies</h3>
                        <p>Help us understand how you use our website.</p>
                      </div>
                      <input type="checkbox" />
                    </div>
                    <p>These cookies collect information about how you interact with our site, helping us improve performance and user experience.</p>
                  </div>
                )}
                <button className={`cookie-nav-item ${activeTab === 'targeting' ? 'active' : ''}`} onClick={() => setActiveTab('targeting')}>Targeting Cookies</button>
                {activeTab === 'targeting' && (
                  <div className="cookie-modal-main">
                    <div className="cookie-toggle-header">
                      <div>
                        <h3>Targeting Cookies</h3>
                        <p>Enable personalized content and ads.</p>
                      </div>
                      <input type="checkbox" />
                    </div>
                    <p>These cookies track your behavior to deliver personalized content and advertisements based on your interests.</p>
                  </div>
                )}
                <button className={`cookie-nav-item ${activeTab === 'functional' ? 'active' : ''}`} onClick={() => setActiveTab('functional')}>Functional Cookies</button>
                {activeTab === 'functional' && (
                  <div className="cookie-modal-main">
                    <div className="cookie-toggle-header">
                      <div>
                        <h3>Functional Cookies</h3>
                        <p>Remember your preferences and choices.</p>
                      </div>
                      <input type="checkbox" />
                    </div>
                    <p>These cookies remember your settings, preferences, and login information to provide a personalized experience across sessions.</p>
                  </div>
                )}
              </nav>
            </div>
            <div className="cookie-modal-footer">
              <button className="cookie-modal-reject" onClick={handleCookieClick}>Reject All</button>
              <button className="cookie-modal-save" onClick={handleCookieClick}>Save Preferences</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ScrollToTop;
